module.exports = __webpack_public_path__ + "static/media/AssignTo.dbd2139a.svg";